import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: [],        
        item: {},
        extensions: [],
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
        extensions: state => state.extensions,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        },
        setExtensions(state, extensions) {
            state.extensions = extensions;
        },
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('pbxware/ivrs', {
                params: {
                    server_id: rootState.route.meta.serverId
                }
            });

            commit('setItems', response.data.items);
            commit('setExtensions', response.data.extensions);

            return response;
        },
        async edit({ commit, rootState }, id) {
            const response = await http.get(`pbxware/ivrs/${id}/edit`, {
                params: {
                    server_id: rootState.route.meta.serverId
                }
            });

            commit('setItem', response.data);

            return response;
        },
        async update({ commit, rootState }, payload) {
            payload.server_id = rootState.route.meta.serverId;
            const response = await http.patch(`pbxware/ivrs/${payload.id}`, payload);

            commit('setItem', response.data);

            return response;
        },
        async store({ commit, rootState }, payload) {
            payload.server = rootState.route.meta.serverId;
            const response = await http.post(`pbxware/ivrs`, payload);

            return response;
        },
        async delete({ commit, rootState }, id) {
            const response = await http.delete(`pbxware/ivrs/${id}`, {
                params: {server_id: rootState.route.meta.serverId}
            });

            return response;
        }
    }
}